import { startOfDay } from 'date-fns';

/**
 * Latest segment departure across all slices on a trip (return leg for roundtrips).
 * Falls back to booking-level departure_date when slice data is missing.
 */
export function getTripFinalDepartureDate(trip) {
  const bookings = Array.isArray(trip) ? trip : trip ? [trip] : [];
  let latest = null;

  for (const booking of bookings) {
    const fd = booking?.flightData || booking?.flight_data || {};
    const slices = Array.isArray(fd.slices) ? fd.slices : [];

    for (const slice of slices) {
      for (const segment of slice.segments || []) {
        const raw = segment?.departing_at;
        if (!raw) continue;
        const d = new Date(raw);
        if (!Number.isFinite(d.getTime())) continue;
        if (!latest || d > latest) latest = d;
      }
    }

    if (slices.length === 0) {
      const depDate = booking?.departure_date || booking?.departureDate;
      if (depDate) {
        const d = new Date(`${String(depDate).slice(0, 10)}T00:00:00`);
        if (Number.isFinite(d.getTime()) && (!latest || d > latest)) latest = d;
      }
    }
  }

  return latest;
}

export function isTripFinalDeparturePast(trip, now = new Date()) {
  const finalDeparture = getTripFinalDepartureDate(trip);
  if (!finalDeparture) return false;
  return startOfDay(finalDeparture) < startOfDay(now);
}

/**
 * Flight Options should be unavailable for terminal trips and after the last
 * flight has departed.
 */
export function getFlightOptionsState(trip, now = new Date()) {
  const bookings = Array.isArray(trip) ? trip : trip ? [trip] : [];
  const main = bookings[0];
  if (!main) return { disabled: true, reason: 'no_booking' };

  const status = String(main.trip_status || main.status || '').toLowerCase();
  if (status === 'cancelled' || status === 'canceled' || status === 'defaulted') {
    return { disabled: true, reason: status };
  }

  if (isTripFinalDeparturePast(trip, now)) {
    return { disabled: true, reason: 'departure_past' };
  }

  return { disabled: false };
}

export function isTripCompleted(trip) {
  const bookings = Array.isArray(trip) ? trip : trip ? [trip] : [];
  const main = bookings[0];
  if (!main) return false;
  const status = String(main.trip_status || main.status || '').toLowerCase();
  return status === 'completed';
}
